import React, { useContext, useEffect, useState } from 'react';
import Application from '../../../StateContext/Application.js';
import { apiurl } from '../../../../../path.js';
import * as XLSX from 'xlsx';
import "./BudgetEstimation.css";
import { Cancel32 } from '../../../../../public/LoginImages/importimages';
import { useLanguage } from '../../../../../lang/langcontext/LanguageContext.js';


const BudgetEstimation = () => {
  const { language, toggleLanguage, t } = useLanguage();
  const operation = useContext(Application);
  const { GetBudgetHeadInfo, ReleaseFDUTF } = operation;
  const [loading, setLoading] = useState(false);
  const [AllHeadID, setAllHeadID] = useState([]);
  const [AllDistrict, setAllDistrict] = useState([]);
  const [TalukasofDistrict, setTalukasofDistrict] = useState([]);
  const [GRData, setGRData] = useState([]);
  const [AllGRID, setAllGRID] = useState([]);
  const [AllProposalID, setAllProposalID] = useState([]);
  const [AllLimitAllocation, setAllLimitAllocation] = useState([]);
  const [originalLimitAllocatedCost, setOriginalLimitAllocatedCost] = useState(0);
  const [tableData, setTableData] = useState([]);
  const [editIndex, setEditIndex] = useState(null);
  const [indexofediting, setIndexofEditing] = useState(null);
  const [ShowMenu, setShowMenu] = useState(0);


  const [data, setData] = useState({
    FinancialYear: '',
    District: "",
    HeadID: "",
    HeadName: "",
    Taluka: "",
    GRID: "",
    ProposalID: "",
    LimitAllocatedcost: "0",
    ProposalCost: "",
    ReleaseAmountTillDate: '',
    ReleaseAmount: 0,
    ReleaseDate: null,
    ProjectName: '',
    ProjectID: '',
    BudgetHeadID: '',
    BudgetHeadName: "",
    type: "Head"
  });

  const HandleChangeData = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  }


  useEffect(() => {
    setData({ ...data, ReleaseAmountTillDate: data.ReleaseAmount });
  }, [data.ReleaseAmount]);


  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!tableData.length) {
      alert("No entries added to submit.");
      return;
    }

    try {
      setLoading(true);
      console.log("Table data :: ", tableData);

      let result = await ReleaseFDUTF(tableData, "Head");
      console.log(result)
      if (result.message) {
        alert(result.message)
        window.location.reload();
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
    finally {
      setLoading(false);
    }

  };

  // Fetching 
  const FetchData = async () => {
    try {
      let res1 = await GetBudgetHeadInfo('null', "AllHeadCode");
      let res2 = await GetBudgetHeadInfo('null', "AllDistrict");
      let res3 = await GetBudgetHeadInfo('null', "GetAllBudgetEstimationData");
      setAllHeadID(res1);
      setAllDistrict(res2);
      setAllLimitAllocation(res3);
    }
    catch (err) {
      console.log(err);
    }
  }



  useEffect(() => {
    FetchData()
  }, []);


  const HeadDetailSetting = (id) => {
    let res = AllHeadID.filter((item) => item.HeadID == id);
    const { HeadID, HeadName } = res[0];
    setData({ ...data, HeadID: HeadID, HeadName: HeadName });
  }


  const handleAddToTable = (e) => {
    e.preventDefault();

    if (!data.FinancialYear || !data.HeadID || !data.District || !data.HeadName || !data.LimitAllocatedcost || !data.ReleaseDate || !data.ReleaseAmount || !data.ReleaseAmountTillDate) {
      alert("Please fill all required fields.");
      return;
    };

    const isDuplicate = tableData.some(
      (entry) =>
        entry.HeadID === data.HeadID &&
        entry.FinancialYear === data.FinancialYear
    );

    if (isDuplicate) {
      alert("This Head and Financial Year already exists!");
      return;
    }

    setTableData([...tableData, data]);

    setData({
      FinancialYear: '',
      District: "",
      HeadID: "",
      HeadName: "",
      Taluka: "",
      GRID: "",
      ProposalID: "",
      LimitAllocatedcost: "0",
      ProposalCost: "",
      ReleaseAmountTillDate: '',
      ReleaseAmount: 0,
      ReleaseDate: null,
      ProjectName: '',
      ProjectID: '',
      BudgetHeadID: '',
      BudgetHeadName: "",
      type: "Head"
    });
  }


  // limit allocation fucniton 

  // useEffect(() => {
  //   if (data.FinancialYear && data.HeadCode && data.District) {
  //     let res = AllLimitAllocation.filter((item) => item.Year == data.FinancialYear && item.BudgetID == data.HeadCode && item.Taluka == data.District);
  //     setData({
  //       ...data,
  //       LimitAllocatedcost: res[0].LimitAllotedAmount ? res[0].LimitAllotedAmount : 0
  //     });
  //     setOriginalLimitAllocatedCost(res[0].LimitAllotedAmount ? res[0].LimitAllotedAmount : 0)
  //   }
  // }, [data.FinancialYear, data.HeadCode, data.District]);


  // const GetSpecificGRDatabyTalukaDistrict = async () => {
  //   try {
  //     let obj = {
  //       HID: data.HeadCode,
  //       PY: data.FinancialYear,
  //       ZP: data.District,
  //       Ta: data.Taluka
  //     };

  //     let res = await GetBudgetHeadInfo(obj, "GetSpecificGRData");
  //     setGRData(res);

  //     let grid = [...new Set(res.map(val => val.GRID))];
  //     setAllGRID(grid)
  //   }
  //   catch (err) {
  //     console.log(err);
  //   }
  // }

  // useEffect(() => {
  //   if (data.FinancialYear && data.HeadCode && data.District && data.Taluka) {
  //     GetSpecificGRDatabyTalukaDistrict();
  //   }
  // }, [data.FinancialYear, data.HeadCode, data.District, data.Taluka]);


  // useEffect(() => {
  //   if (data.FinancialYear && data.HeadCode && data.District && data.Taluka && data.GRID) {
  //     let res = GRData.filter((item) => item.GRID === data.GRID);
  //     console.log("Data for Propodal id :: ", res)
  //     setAllProposalID(res);
  //   }
  // }, [data.GRID]);


  // const proposalIDcostsetting = (proposalID) => {
  //   if (data.FinancialYear && data.HeadCode && data.District && data.Taluka && data.GRID) {
  //     let res = AllProposalID.filter((item) => item.Work_name === proposalID);
  //     setData({ ...data, ProposalCost: res[0].ProposalAmount, ProposalID: proposalID });
  //   }
  // };


  // const GetReleaseFromFinanceLastamount = async (rowData) => {
  //   try {
  //     let obj = {
  //       HID: rowData.HeadCode,
  //       PY: rowData.FinancialYear,
  //       ZP: rowData.District,
  //       Ta: rowData.Taluka,
  //       GID: rowData.GRID,
  //       PID: rowData.ProposalID
  //     };

  //     let res = await GetBudgetHeadInfo(obj, "GetSpecificReleaseAmount");
  //     console.log(res);

  //     let Ramount = res?.[0]?.ReleaseAmountTillDate || 0;


  //     let res1 = AllProposalID.filter((item) => item.ProposalID === data.ProposalID);
  //     console.log(res1);

  //     setData(prevData => ({
  //       ...prevData,
  //       ReleaseAmountTillDate: Ramount,
  //       ProposalCost: res1[0]?.ProposalAmount || 0
  //     }));
  //   }
  //   catch (err) {
  //     console.log(err);
  //   }
  // }

  // useEffect(() => {
  //   if (data.FinancialYear && data.HeadCode && data.District && data.Taluka && data.GRID && data.ProposalID) {
  //     GetReleaseFromFinanceLastamount();
  //   }
  // }, [data.ProposalID]);



  // useEffect(() => {
  //   if (originalLimitAllocatedCost) {
  //     let remainingCost = Number(originalLimitAllocatedCost) - Number(data.ReleaseAmount || 0);
  //     setData(prev => ({ ...prev, LimitAllocatedcost: remainingCost }));
  //   } else {
  //     setData(prev => ({ ...prev, ReleaseAmount: 0 }));
  //   }
  // }, [data.ReleaseAmount, originalLimitAllocatedCost]);







  // excel 

  const convertExcelDate = (excelDate) => {
    if (typeof excelDate === 'number') {
      // Convert Excel serial number to JS date
      const date = new Date((excelDate - 25569) * 86400 * 1000);
      return date.toISOString().split('T')[0]; // Output: YYYY-MM-DD
    }

    // If it's already a date string (e.g., 2025-06-24T12:40), extract date part
    if (typeof excelDate === 'string') {
      const parsed = new Date(excelDate);
      if (!isNaN(parsed)) {
        return parsed.toISOString().split('T')[0];
      }
    }

    // If it's not valid, return as-is or handle error/log
    return null;
  };

  // const handleFileUpload = (e) => {
  //   try {
  //     const file = e.target.files[0];
  //     if (!file) {
  //       console.warn("No file selected.");
  //       return;
  //     }

  //     console.log("File selected:", file);
  //     const reader = new FileReader();

  //     reader.onload = (evt) => {
  //       const binaryStr = evt.target.result;

  //       try {
  //         const workbook = XLSX.read(binaryStr, { type: 'binary' });
  //         const worksheetName = workbook.SheetNames[0];
  //         const worksheet = workbook.Sheets[worksheetName];
  //         const jsonData = XLSX.utils.sheet_to_json(worksheet);

  //         console.log('Parsed Excel Data:', jsonData);

  //         const formattedData = jsonData
  //           .filter(row =>
  //             row['आर्थिक वर्ष'] &&
  //             row['जिल्हा'] &&
  //             row['अर्थसंकल्प शिर्षक क्रमांक'] &&
  //             row['अर्थसंकल्प शिर्षकाचे नाव'] &&
  //             row['दिनांक'] &&
  //             (row['आतापर्यंत वितरीत केलेली रक्कम'] || 0) &&
  //             (row['या आदेशान्वये वितरीत करावयाची रक्कम'] || 0)
  //           ).
  //           map(row => ({
  //             FinancialYear: row['आर्थिक वर्ष'],
  //             District: row['जिल्हा'],
  //             HeadID: row['अर्थसंकल्प शिर्षक क्रमांक'],
  //             HeadName: row['अर्थसंकल्प शिर्षकाचे नाव'],
  //             ReleaseDate: convertExcelDate(row['दिनांक']),
  //             ReleaseAmountTillDate: row['आतापर्यंत वितरीत केलेली रक्कम'],
  //             ReleaseAmount: row['आतापर्यंत वितरीत केलेली रक्कम'],
  //             LimitAllocatedcost: row['या आदेशान्वये वितरीत करावयाची रक्कम']
  //           }));

  //         console.log("Formatted Data:", formattedData);

  //         // You can now use `formattedData` e.g. store it in state:
  //         // setData(formattedData);
  //         setTableData(formattedData)

  //       } catch (parseErr) {
  //         console.error("Error parsing Excel file:", parseErr);
  //       }
  //     };

  //     reader.readAsBinaryString(file);
  //   } catch (error) {
  //     console.error("File upload failed:", error);
  //   }
  // };

  const handleFileUpload = (e) => {

    const file = e.target.files[0];
    if (!file) return;

    const allowedTypes = [
      "application/pdf",
      "application/vnd.ms-excel", // .xls
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
      "image/jpeg",
      "image/png",
    ];

    if (!allowedTypes.includes(file.type)) {
      alert("Only PDF, Excel, JPG, JPEG, PNG files are allowed");
      e.target.value = ""; // Reset input
      return;
    }

    try {
      const file = e.target.files[0];
      if (!file) {
        console.warn("No file selected.");
        return;
      }

      console.log("File selected:", file);
      const reader = new FileReader();

      reader.onload = (evt) => {
        const binaryStr = evt.target.result;

        try {
          const workbook = XLSX.read(binaryStr, { type: 'binary' });
          const worksheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[worksheetName];
          const jsonData = XLSX.utils.sheet_to_json(worksheet);

          console.log('Parsed Excel Data:', jsonData);

          const formattedData = jsonData
            .filter(row =>
              row['आर्थिक वर्ष'] &&
              row['जिल्हा'] &&
              row['अर्थसंकल्प शिर्षक क्रमांक'] &&
              row['अर्थसंकल्प शिर्षकाचे नाव'] &&
              row['दिनांक'] &&
              (row['आतापर्यंत वितरीत केलेली रक्कम'] || 0) &&
              (row['या आदेशान्वये वितरीत करावयाची रक्कम'] || 0)
            ).
            map(row => ({
              FinancialYear: row['आर्थिक वर्ष'],
              District: row['जिल्हा'],
              HeadID: row['अर्थसंकल्प शिर्षक क्रमांक'],
              HeadName: row['अर्थसंकल्प शिर्षकाचे नाव'],
              ReleaseDate: convertExcelDate(row['दिनांक']),
              ReleaseAmountTillDate: row['आतापर्यंत वितरीत केलेली रक्कम'],
              ReleaseAmount: row['आतापर्यंत वितरीत केलेली रक्कम'],
              LimitAllocatedcost: row['या आदेशान्वये वितरीत करावयाची रक्कम']
            }));

          console.log("Formatted Data:", formattedData);

          // You can now use `formattedData` e.g. store it in state:
          // setData(formattedData);
          setTableData(formattedData)

        } catch (parseErr) {
          console.error("Error parsing Excel file:", parseErr);
        }
      };

      reader.readAsBinaryString(file);
    } catch (error) {
      console.error("File upload failed:", error);
    }
  };

  const handelchangeTablre = (e) => {
    e.preventDefault();
    const updatedData = [...tableData];
    updatedData[indexofediting] = editIndex;
    setTableData(updatedData);

    setEditIndex(null);
    setIndexofEditing(null);
  };


  const handleEdit = (e, index) => {
    e.preventDefault();
    setEditIndex({ ...tableData[index] });
    setIndexofEditing(index);
  };



  // const updateLimitAllocatedCosts = (updatedTable) => {
  //   return updatedTable.map((row) => {
  //     const { FinancialYear, HeadCode, District } = row;

  //     const originalLimit = AllLimitAllocation.find(
  //       item =>
  //         item.Year == FinancialYear &&
  //         item.BudgetID == HeadCode &&
  //         item.Taluka == District
  //     )?.LimitAllotedAmount || 0;

  //     const totalReleased = updatedTable.reduce((sum, r) => {
  //       return (r.FinancialYear === FinancialYear &&
  //         r.HeadCode === HeadCode &&
  //         r.District === District)
  //         ? sum + Number(r.ReleaseAmount || 0)
  //         : sum;
  //     }, 0);

  //     return {
  //       ...row,
  //       LimitAllocatedcost: originalLimit - totalReleased
  //     };
  //   });
  // };


  const handleSubmitBulk = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // let ReleaseSanctionCopy = document.getElementById("ReleaseSanctionCopy").files;
      // formData.append("ReleaseSanctionCopy", ReleaseSanctionCopy[0]);
      let result = await ReleaseFDUTF(tableData, "Head");
      console.log(result)
      if (result.message) {
        alert(result.message)
        window.location.reload();
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
    finally {
      setLoading(true);
    }

  };



  useEffect(() => {
    setTableData([]);
  }, [ShowMenu])



  // return (
  //   <>


  //     <div className="col-12" style={{ height: "90vh", overflowY: "scroll", overflowX: 'hidden', scrollBehavior: "smooth" }}>
  //       <div className="col-12 py-4" style={{ background: "#EFF3F8" }}>

  //         <div className="col-10 m-auto">
  //           <div className="row">

  //             <div className="col-12 d-flex justify-content-end">
  //               <button
  //                 className="btn px-5 mx-4 fw-bold"
  //                 style={{
  //                   background: "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
  //                   color: "white", borderRadius: "7px"
  //                 }}
  //                 onClick={() => setShowMenu(0)}
  //               >Form</button>
  //               <button
  //                 className="btn px-5 fw-bold"
  //                 style={{
  //                   backgroundColor: "#009245", color: "white", borderRadius: "7px"
  //                 }}
  //                 onClick={() => setShowMenu(1)}
  //               >Excel</button>
  //             </div>
  //           </div>
  //         </div>
  //       </div>


  //       {
  //         ShowMenu == 0 &&
  //         (
  //           <>
  //             <div className="col-12" style={{ background: "#EFF3F8", paddingBottom: "6vh" }}>

  //               <div className="col-12 m-auto budgetContainer">

  //                 <div className="m-auto budgetElement">
  //                   <div className="col-6 mb-5">
  //               <h4 className='fw-bold' >Limit Allocation (Head Wise)</h4>
  //             </div>
  //                   <form action="">

  //                     <div className="col-12 elements">
  //                       <div className="row">
  //                         <div className="elementsPart1">
  //                           <label className='fw-bold'>Financial Year</label>
  //                         </div>
  //                         <div className="elementsPart2">
  //                           <select name="FinancialYear" value={data.FinancialYear} id="" className='py-2' onChange={HandleChangeData} required>
  //                             <option value="null">Choose Financial Year</option>
  //                             <option value="2024-2025">2024 - 2025</option>
  //                             <option value="2025-2026">2025 - 2026</option>
  //                           </select>
  //                         </div>
  //                       </div>
  //                     </div>

  //                     <div className="col-12 elements">
  //                       <div className="row">
  //                         <div className="elementsPart1">
  //                           <label className='fw-bold'>Zilla Parishad</label>
  //                         </div>
  //                         <div className="elementsPart2">
  //                           <select name="District" value={data.District} className='py-2' onChange={HandleChangeData} required>
  //                             <option value="">Choose Zilla</option>
  //                             {
  //                               AllDistrict &&
  //                               [...new Set(AllDistrict.map(val => val.District_Marathi))].map((district, index) => {
  //                                 return (
  //                                   <option key={index} value={district}>{district}</option>
  //                                 )
  //                               })
  //                             }
  //                           </select>
  //                         </div>
  //                       </div>
  //                     </div>

  //                     <div className="col-12 elements">
  //                       <div className="row">
  //                         <div className="elementsPart1">
  //                           <label className='fw-bold'>Head Name</label>
  //                         </div>
  //                         <div className="elementsPart2">
  //                           <select name="HeadCode" value={data.HeadID} className='py-2' onChange={(e) => HeadDetailSetting(e.target.value)} required>
  //                             <option value="">Choose Head Name</option>
  //                             {
  //                               AllHeadID &&
  //                               AllHeadID.map((val, index) => {
  //                                 return (
  //                                   <option key={index} value={val.HeadID}>{val.HeadName}</option>
  //                                 )
  //                               })
  //                             }
  //                           </select>
  //                         </div>
  //                       </div>
  //                     </div>



  //                     {/* <div className="col-12 elements">
  //                 <div className="row">
  //                   <div className="col-5  ">
  //                     <label>Taluka</label>
  //                   </div>
  //                   <div className="col-7">
  //                     <select name="Taluka" value={data.Taluka} className='py-2' onChange={HandleChangeData} required>
  //                       <option value="">Choose Taluka</option>
  //                       {
  //                         TalukasofDistrict.length > 0 &&
  //                         TalukasofDistrict.map((val, index) => {
  //                           return (
  //                             <option key={index} value={val.ULBNameMarathi}>{val.ULBNameMarathi}</option>
  //                           )
  //                         })
  //                       }
  //                     </select>
  //                   </div>
  //                 </div>
  //               </div> */}

  //                     {/* <div className="col-12 elements">
  //                 <div className="row">
  //                   <div className="col-5  ">
  //                     <label>GR</label>
  //                   </div>
  //                   <div className="col-7">
  //                     <select name="GRID" value={data.GRID} className='py-2' onChange={HandleChangeData} required>
  //                       <option value="">Choose GR</option>
  //                       {
  //                         AllGRID.length > 0 &&
  //                         AllGRID.map((val, index) => {
  //                           return (
  //                             <option key={index} value={val}>{val}</option>
  //                           )
  //                         })
  //                       }
  //                     </select>
  //                   </div>
  //                 </div>
  //               </div> */}

  //                     {/* <div className="col-12 elements">
  //                 <div className="row">
  //                   <div className="col-5  ">
  //                     <label>Proposal</label>
  //                   </div>
  //                   <div className="col-7">
  //                     <select name="ProposalID" value={data.ProposalID} className='py-2' onChange={(e) => { HandleChangeData(e); proposalIDcostsetting(e.target.value) }} required>
  //                       <option value="">Choose Proposal</option>
  //                       {
  //                         AllProposalID.length > 0 &&
  //                         AllProposalID.map((val, index) => {
  //                           return (
  //                             <option key={index} value={val.Work_name}>{val.Work_name}</option>
  //                           )
  //                         })
  //                       }
  //                     </select>
  //                   </div>
  //                 </div>
  //               </div> */}


  //                     {/* <div className="col-12 elements">
  //                 <div className="row">
  //                   <div className="col-5  ">
  //                     <label>Proposal Cost</label>
  //                   </div>
  //                   <div className="col-7">
  //                     <input type="text" className='form-control py-2' value={data.ProposalCost || 0} disabled />
  //                   </div>
  //                 </div>
  //               </div> */}

  //                     <div className="col-12 elements">
  //                       <div className="row">
  //                         <div className="elementsPart1">
  //                           <label className='fw-bold'>Limit Allocated Cost</label>
  //                         </div>
  //                         <div className="col-5">
  //                           <input type="text" className='form-control py-2' value={data.LimitAllocatedcost < 0 ? 0 : data.LimitAllocatedcost} name='LimitAllocatedcost' onChange={HandleChangeData} />
  //                         </div>

  //                         <div className="col-2 my-auto">
  //                           <p className='my-auto fw-bold'>( CR )</p>
  //                         </div>
  //                       </div>
  //                     </div>

  //                     {/* <div className="col-12 elements">
  //                 <div className="row">
  //                   <div className="col-5">
  //                     <label className='my-auto'>Release Amount Till Date</label>
  //                   </div>
  //                   <div className="col-7">
  //                     <input type="text" className='form-control py-2' value={data.ReleaseAmountTillDate || 0} disabled />
  //                   </div>
  //                 </div>
  //               </div> */}

  //                     <div className="col-12 elements">
  //                       <div className="row">
  //                         <div className="elementsPart1">
  //                           <label className='fw-bold'>Release Amount Till Date</label>
  //                         </div>
  //                         <div className="col-5">
  //                           <input type="number" className='form-control' name='ReleaseAmount' value={data.ReleaseAmount < 0 ? 0 : data.ReleaseAmount} onChange={HandleChangeData} required />
  //                         </div>
  //                         <div className="col-2 my-auto">
  //                           <p className='my-auto fw-bold'>( CR )</p>
  //                         </div>
  //                       </div>
  //                     </div>

  //                     <div className="col-12 elements">
  //                       <div className="row">
  //                         <div className="elementsPart1">
  //                           <label className='fw-bold'>Release Date</label>
  //                         </div>
  //                         <div className="col-5">
  //                           <input type="datetime-local" placeholder='Enter Release Date' className='form-control py-2' value={data.ReleaseDate} name='ReleaseDate' onChange={HandleChangeData} required />
  //                         </div>
  //                       </div>
  //                     </div>

  //                     {/* <div className="col-12 elements">
  //                 <div className="row">
  //                   <div className="col-5">
  //                     <label>Release Sanction Copy Upload</label>
  //                   </div>
  //                   <div className="col-7">
  //                     <input type="file" className='form-control py-2' id='ReleaseSanctionCopy' required />
  //                   </div>
  //                 </div>
  //               </div> */}

  //                     <div className="col-12">
  //                       <div className="row">
  //                         <div className="col-12">
  //                           <div className="col-12 text-center mt-4">
  //                             <button
  //                               className='px-4 py-1 btn fw-bold'
  //                               style={{
  //                                 background: "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
  //                                 color: "white", borderRadius: "7px"
  //                               }}
  //                               onClick={handleAddToTable}> Save</button>
  //                             <button className='px-4 py-1 btn mx-4 fw-bold'
  //                               style={{
  //                                 backgroundColor: "#C1272D",
  //                                 color: "white", borderRadius: "7px"
  //                               }}
  //                             > Cancel</button>
  //                           </div>
  //                         </div>
  //                       </div>
  //                     </div>
  //                   </form>
  //                 </div>
  //               </div>
  //             </div>


  //             {
  //               tableData &&
  //               tableData.length > 0 &&
  //               (
  //                 <div className='m-auto' style={{ width: "98%", backgroundColor: "white", padding: "20px 20px", boxShadow: "0px 0px 5px 1px #c7c9cc", borderRadius: "20px" }}>
  //                   <div className="col-12 text-end">
  //                     <button
  //                       className='px-4 py-1 btn fw-bold mb-3'
  //                       style={{
  //                         backgroundColor: "#39B54A",
  //                         color: "white", borderRadius: "7px"
  //                       }}
  //                       onClick={handleSubmit}>Submit</button>
  //                   </div>

  //                   <div className='col-12 tableDesign' style={{ background: '#2C78DB' }}>
  //                     <div>
  //                       <table className='m-0 p-0' style={{ width: '100%', borderCollapse: 'collapse' }}>
  //                         <thead>
  //                           <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "12px" }}>
  //                             <th style={{ width: "10%" }}>आर्थिक वर्ष</th>
  //                             <th style={{ width: "10%" }}>जिल्हा</th>
  //                             <th style={{ width: "10%" }}>अर्थसंकल्प शिर्षक क्रमांक</th>
  //                             <th style={{ width: "10%" }}>अर्थसंकल्प शिर्षकाचे नाव</th>
  //                             <th style={{ width: "10%" }}>दिनांक</th>
  //                             <th style={{ width: "15%" }}>या आदेशान्वये वितरीत करावयाची रक्कम</th>
  //                             <th style={{ width: "12%" }}>आतापर्यंत वितरीत केलेली रक्कम</th>
  //                           </tr>
  //                         </thead>
  //                         <tbody>
  //                           {
  //                             tableData.map((val, index) => {
  //                               return (
  //                                 <tr key={index} style={{ backgroundColor: index % 2 === 0 ? "#E5F4FB" : "#c6dae7", height: '2rem' }}>
  //                                   <td className='py-2'>{val.FinancialYear}</td>
  //                                   <td className='py-2'>{val.District}</td>
  //                                   <td className='py-2'>{val.HeadID}</td>
  //                                   <td className='py-2'>{val.HeadName}</td>
  //                                   <td className='py-2'>{val.ReleaseDate}</td>
  //                                   <td className='py-2'>
  //                                     {
  //                                       val.LimitAllocatedcost || 0
  //                                     } CR
  //                                   </td>
  //                                   <td className='py-2'>{val.ReleaseAmountTillDate} CR</td>
  //                                 </tr>
  //                               )
  //                             })
  //                           }
  //                         </tbody>
  //                       </table>
  //                     </div>
  //                   </div>
  //                 </div>
  //               )
  //             }
  //           </>
  //         )
  //       }

  //       {
  //         ShowMenu == 1 &&
  //         <div className="col-12" style={{ background: "#EFF3F8", paddingBottom: "6vh", height: "100%" }}>
  //           <div className="m-auto financeContainer">
  //             <div className="m-auto budgetElement">
  //               {loading && (
  //                 <div
  //                   style={{
  //                     position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(255, 255, 255, 0.7)', backdropFilter: 'blur(4px)', zIndex: 9999,
  //                     display: 'flex', justifyContent: 'center', alignItems: 'center'
  //                   }}>
  //                   <div style={{ border: '6px solid #f3f3f3', borderTop: '6px solid #007bff', borderRadius: '50%', width: '60px', height: '60px', animation: 'spin 1s linear infinite' }} />
  //                   <style>
  //                     {`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}
  //                   </style>
  //                 </div>
  //               )}

  //               <div className="excelContainer m-auto">
  //                 <div className='col-12 m-auto px-3'>
  //                   <form >
  //                     <div className='col-12'>
  //                       <div className='row'>
  //                         <div className='col-12'>
  //                           <label className='fw-bold mb-2' style={{ fontSize: "16px" }}>Upload Excel File</label>
  //                         </div>

  //                         <div className="col-12">
  //                           <input
  //                             type="file"
  //                             className="form-control py-2"
  //                             style={{ borderRadius: '0' }}
  //                             accept=".xlsx, .xls"
  //                             onChange={handleFileUpload}
  //                           />
  //                         </div>
  //                       </div>
  //                     </div>


  //                     <p className='my-3 fw-bold' style={{ fontSize: "16px" }}>File Format for Upload ::
  //                       {
  //                         <a href={`${apiurl}/FinancialReleaseGR/FileFormatForUpload.xlsx`} target='_blank'> File Format for Finance ( Head Wise ) Excel
  //                         </a>}
  //                     </p>


  //                     {
  //                       editIndex &&
  //                       <div className="col-12">
  //                         <div className="col-8 m-auto rounded p-4 border border-dark">
  //                           <form action="">
  //                             <div className="row">

  //                               <div className="col-12 my-2">
  //                                 <div className="row">
  //                                   <div className="col-6">
  //                                     <label>अर्थसंकल्प शिर्षकाचे नाव</label>
  //                                   </div>

  //                                   <div className="col-6">
  //                                     <input type="text" value={editIndex.HeadName} disabled />
  //                                   </div>

  //                                 </div>
  //                               </div>

  //                               <div className="col-12 my-2">
  //                                 <div className="row">
  //                                   <div className="col-6">
  //                                     <label>या आदेशान्वये वितरीत करावयाची रक्कम</label>
  //                                   </div>

  //                                   <div className="col-3">
  //                                     <input type="text" value={editIndex.LimitAllocatedcost} name='LimitAllocatedcost' onChange={(e) => setEditIndex({ ...editIndex, LimitAllocatedcost: e.target.value })} />
  //                                   </div>

  //                                   <div className="col-3 my-auto">
  //                                     <p className='fw-bold my-auto'>कोटी</p>
  //                                   </div>



  //                                 </div>
  //                               </div>

  //                               <div className="col-12 my-4 text-center">
  //                                 <button className='btn btn-success px-5 fw-bold' onClick={(e) => handelchangeTablre(e)}>Submit</button>
  //                               </div>

  //                             </div>
  //                           </form>
  //                         </div>
  //                       </div>
  //                     }


  //                     {
  //                       tableData &&
  //                       tableData.length > 0 &&
  //                       (
  //                         <div className="col-12 my-3">
  //                           <div className="row">

  //                             <div className="col-12">


  //                               <div className="tableContainer m-auto">
  //                                 <table style={{ border: '1px solid green' }}>
  //                                   <thead>
  //                                     <tr style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', height: '2.5rem' }}>
  //                                       <th style={{ width: "10%", textAlign: "start" }}>आर्थिक वर्ष</th>
  //                                       {/* <th style={{ width: "10%", textAlign: "start" }}>Head Name</th> */}
  //                                       <th style={{ width: "10%", textAlign: "start" }}>जिल्हा</th>
  //                                       <th style={{ width: "10%", textAlign: "start" }}>अर्थसंकल्प शिर्षक क्रमांक</th>
  //                                       {/* <th style={{ width: "10%", textAlign: "start" }}>Year</th>
  //                                       <th style={{ width: "20%", textAlign: "start" }}>Budget Head</th>
  //                                       <th style={{ width: "15%", textAlign: "start" }}>Taluka</th> */}
  //                                       <th style={{ width: "10%", textAlign: "start" }}>अर्थसंकल्प शिर्षकाचे नाव</th>
  //                                       {/* <th style={{ width: "10%", textAlign: "start" }}>प्रस्तावाचे नाव</th> */}
  //                                       <th style={{ width: "10%", textAlign: "start" }}>दिनांक</th>
  //                                       {/* <th style={{ width: "10%", textAlign: "start" }}>मंजूर रक्कम</th> */}
  //                                       <th style={{ width: "10%", textAlign: "start" }}>आतापर्यंत वितरीत केलेली रक्कम</th>
  //                                       <th style={{ width: "10%", textAlign: "start" }}>या आदेशान्वये वितरीत करावयाची रक्कम</th>
  //                                       {/* <th style={{ width: "10%", textAlign: "start" }}>District-wise Fund Distribution</th> */}
  //                                       {/* <th style={{ width: "15%", textAlign: "start" }}>Date</th> */}
  //                                       <th style={{ width: "10%", textAlign: "start" }}></th>
  //                                     </tr>
  //                                   </thead>
  //                                   <tbody>
  //                                     {
  //                                       tableData.map((val, index) => {
  //                                         return (
  //                                           <tr key={index} style={{ backgroundColor: index % 2 === 0 ? "#E5F4FB" : "#c6dae7", height: '2rem' }}>
  //                                             <td style={{ textAlign: "start" }}>{val.FinancialYear}</td>
  //                                             {/* <td style={{ textAlign: "start" }}>{val.HeadName}</td> */}
  //                                             <td style={{ textAlign: "start" }}>{val.District}</td>
  //                                             <td style={{ textAlign: "start" }}>{val.HeadID}</td>
  //                                             <td style={{ textAlign: "start" }}>{val.HeadName}</td>
  //                                             {/* <td style={{ textAlign: "start" }}>{val.ProposalID}</td> */}
  //                                             <td style={{ textAlign: "start" }}>{val.ReleaseDate}</td>
  //                                             {/* <td style={{ textAlign: "start" }}>{val.ProposalCost} CR</td> */}
  //                                             <td style={{ textAlign: "start" }}>{val.ReleaseAmountTillDate} CR</td>
  //                                             {/* <td style={{ textAlign: "start" }}>{val.ReleaseAmount}</td> */}
  //                                             <td style={{ textAlign: "start" }}>
  //                                               {
  //                                                 val.LimitAllocatedcost || 0
  //                                               } CR
  //                                             </td>
  //                                             {/* <td style={{ textAlign: "start" }}>{new Date(val.currentDate).toLocaleString()}</td> */}
  //                                             <td>
  //                                               <button className="btn btn-sm btn-primary mx-1" onClick={(e) => handleEdit(e, index)}>Edit</button>
  //                                               {/* <button className="btn btn-sm btn-danger mx-1" onClick={(e) => handleDelete(e, index)}>Delete</button> */}
  //                                             </td>
  //                                           </tr>

  //                                         )
  //                                       })
  //                                     }
  //                                   </tbody>
  //                                 </table>
  //                               </div>
  //                             </div>

  //                           </div>
  //                         </div>
  //                       )
  //                     }


  //                     <div className='col-12 text-center mt-4'>
  //                       <button
  //                         className='btn'
  //                         style={{
  //                           background: "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)", color: "white", borderRadius: "7px"
  //                         }}
  //                         onClick={(e) => handleSubmitBulk(e)}
  //                       > Submit</button>
  //                       <button
  //                         className='btn btn-danger mx-4'
  //                         style={{
  //                           backgroundColor: "#C1272D",
  //                           color: "white", borderRadius: "7px"
  //                         }}
  //                       >
  //                         <img src={Cancel32} style={{ width: '1.2rem' }} onClick={(e) => { e.preventDefault(); window.location.reload() }} /> Cancel</button>
  //                     </div>
  //                   </form>
  //                 </div>
  //               </div>

  //             </div>
  //           </div>
  //         </div>
  //       }


  //     </div>

  //   </>
  // )
  return (
    <>


      <div className="col-12" style={{ height: "90vh", overflowY: "scroll", overflowX: 'hidden', scrollBehavior: "smooth" }}>
        <div className="col-12 py-4" style={{ background: "#EFF3F8" }}>

          <div className="col-10 m-auto">
            <div className="row">

              <div className="col-12 d-flex justify-content-end">
                <button
                  className="btn px-5 mx-4 fw-bold"
                  style={{
                    background: "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
                    color: "white", borderRadius: "7px"
                  }}
                  onClick={() => setShowMenu(0)}
                >{t("Form")}</button>
                <button
                  className="btn px-5 fw-bold"
                  style={{
                    backgroundColor: "#009245", color: "white", borderRadius: "7px"
                  }}
                  onClick={() => setShowMenu(1)}
                >{t("Excel")}</button>
              </div>
            </div>
          </div>
        </div>


        {
          ShowMenu == 0 &&
          (
            <>
              <div className="col-12" style={{ background: "#EFF3F8", paddingBottom: "6vh" }}>

                <div className="col-12 m-auto budgetContainer">

                  <div className="m-auto budgetElement">
                    <div className="col-6 mb-5">
                      <h4 className='fw-bold' >{t("Limit Allocation (Head Wise)")}</h4>
                    </div>
                    <form action="">

                      <div className="col-12 elements">
                        <div className="row">
                          <div className="elementsPart1">
                            <label className='fw-bold'>{t("Financial Year")}</label>
                          </div>
                          <div className="elementsPart2">
                            <select name="FinancialYear" value={data.FinancialYear} id="" className='py-2' onChange={HandleChangeData} required>
                              <option value="null">{t("Choose Financial Year")}</option>
                              <option value="2024-2025">2024 - 2025</option>
                              <option value="2025-2026">2025 - 2026</option>
                              <option value="2026-2027">2026 - 2027</option>
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="col-12 elements">
                        <div className="row">
                          <div className="elementsPart1">
                            <label className='fw-bold'>{t("Zilla Parishad")}</label>
                          </div>
                          <div className="elementsPart2">
                            <select name="District" value={data.District} className='py-2' onChange={HandleChangeData} required>
                              <option value="">{t("Choose Zilla")}</option>
                              {
                                AllDistrict &&
                                [...new Set(AllDistrict.map(val => val.District_Marathi))].map((district, index) => {
                                  return (
                                    <option key={index} value={district}>{district}</option>
                                  )
                                })
                              }
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="col-12 elements">
                        <div className="row">
                          <div className="elementsPart1">
                            <label className='fw-bold'>{t("Head Name")}</label>
                          </div>
                          <div className="elementsPart2">
                            <select name="HeadCode" value={data.HeadID} className='py-2' onChange={(e) => HeadDetailSetting(e.target.value)} required>
                              <option value="">{t("Choose Head Name")}</option>
                              {
                                AllHeadID &&
                                AllHeadID.map((val, index) => {
                                  return (
                                    <option key={index} value={val.HeadID}>{val.HeadName}</option>
                                  )
                                })
                              }
                            </select>
                          </div>
                        </div>
                      </div>



                      {/* <div className="col-12 elements">
                  <div className="row">
                    <div className="col-5  ">
                      <label>Taluka</label>
                    </div>
                    <div className="col-7">
                      <select name="Taluka" value={data.Taluka} className='py-2' onChange={HandleChangeData} required>
                        <option value="">Choose Taluka</option>
                        {
                          TalukasofDistrict.length > 0 &&
                          TalukasofDistrict.map((val, index) => {
                            return (
                              <option key={index} value={val.ULBNameMarathi}>{val.ULBNameMarathi}</option>
                            )
                          })
                        }
                      </select>
                    </div>
                  </div>
                </div> */}

                      {/* <div className="col-12 elements">
                  <div className="row">
                    <div className="col-5  ">
                      <label>GR</label>
                    </div>
                    <div className="col-7">
                      <select name="GRID" value={data.GRID} className='py-2' onChange={HandleChangeData} required>
                        <option value="">Choose GR</option>
                        {
                          AllGRID.length > 0 &&
                          AllGRID.map((val, index) => {
                            return (
                              <option key={index} value={val}>{val}</option>
                            )
                          })
                        }
                      </select>
                    </div>
                  </div>
                </div> */}

                      {/* <div className="col-12 elements">
                  <div className="row">
                    <div className="col-5  ">
                      <label>Proposal</label>
                    </div>
                    <div className="col-7">
                      <select name="ProposalID" value={data.ProposalID} className='py-2' onChange={(e) => { HandleChangeData(e); proposalIDcostsetting(e.target.value) }} required>
                        <option value="">Choose Proposal</option>
                        {
                          AllProposalID.length > 0 &&
                          AllProposalID.map((val, index) => {
                            return (
                              <option key={index} value={val.Work_name}>{val.Work_name}</option>
                            )
                          })
                        }
                      </select>
                    </div>
                  </div>
                </div> */}


                      {/* <div className="col-12 elements">
                  <div className="row">
                    <div className="col-5  ">
                      <label>Proposal Cost</label>
                    </div>
                    <div className="col-7">
                      <input type="text" className='form-control py-2' value={data.ProposalCost || 0} disabled />
                    </div>
                  </div>
                </div> */}

                      <div className="col-12 elements">
                        <div className="row">
                          <div className="elementsPart1">
                            <label className='fw-bold'>{t("Limit Allocated Cost")}</label>
                          </div>
                          <div className="col-5">
                            <input type="text" className='form-control py-2' value={data.LimitAllocatedcost < 0 ? 0 : data.LimitAllocatedcost} name='LimitAllocatedcost' onChange={HandleChangeData} />
                          </div>

                          <div className="col-2 my-auto">
                            <p className='my-auto fw-bold'>( CR )</p>
                          </div>
                        </div>
                      </div>

                      {/* <div className="col-12 elements">
                  <div className="row">
                    <div className="col-5">
                      <label className='my-auto'>Release Amount Till Date</label>
                    </div>
                    <div className="col-7">
                      <input type="text" className='form-control py-2' value={data.ReleaseAmountTillDate || 0} disabled />
                    </div>
                  </div>
                </div> */}

                      <div className="col-12 elements">
                        <div className="row">
                          <div className="elementsPart1">
                            <label className='fw-bold'>{t("Release Amount Till Date")}</label>
                          </div>
                          <div className="col-5">
                            <input type="number" className='form-control' name='ReleaseAmount' value={data.ReleaseAmount < 0 ? 0 : data.ReleaseAmount} onChange={HandleChangeData} required />
                          </div>
                          <div className="col-2 my-auto">
                            <p className='my-auto fw-bold'>( {t("CR")})</p>
                          </div>
                        </div>
                      </div>

                      <div className="col-12 elements">
                        <div className="row">
                          <div className="elementsPart1">
                            <label className='fw-bold'>{t("Release Date")}</label>
                          </div>
                          <div className="col-5">
                            <input type="datetime-local" placeholder={t("Enter Release Date")} className='form-control py-2' value={data.ReleaseDate} name='ReleaseDate' onChange={HandleChangeData} required max={new Date().toISOString().slice(0, 16)} />
                          </div>
                        </div>
                      </div>

                      {/* <div className="col-12 elements">
                  <div className="row">
                    <div className="col-5">
                      <label>Release Sanction Copy Upload</label>
                    </div>
                    <div className="col-7">
                      <input type="file" className='form-control py-2' id='ReleaseSanctionCopy' required />
                    </div>
                  </div>
                </div> */}

                      <div className="col-12">
                        <div className="row">
                          <div className="col-12">
                            <div className="col-12 text-center mt-4">
                              <button
                                className='px-4 py-1 btn fw-bold'
                                style={{
                                  background: "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
                                  color: "white", borderRadius: "7px"
                                }}
                                onClick={handleAddToTable}>{t("Save")}</button>
                              <button className='px-4 py-1 btn mx-4 fw-bold'
                                style={{
                                  backgroundColor: "#C1272D",
                                  color: "white", borderRadius: "7px"
                                }}
                              > {t("Cancel")}</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>


              {
                tableData &&
                tableData.length > 0 &&
                (
                  <div className='m-auto' style={{ width: "98%", backgroundColor: "white", padding: "20px 20px", boxShadow: "0px 0px 5px 1px #c7c9cc", borderRadius: "20px" }}>
                    <div className="col-12 text-end">
                      <button
                        className='px-4 py-1 btn fw-bold mb-3'
                        style={{
                          backgroundColor: "#39B54A",
                          color: "white", borderRadius: "7px"
                        }}
                        onClick={handleSubmit}>{t("Submit")}</button>
                    </div>

                    <div className='col-12 tableDesign' style={{ background: '#2C78DB' }}>
                      <div>
                        <table className='m-0 p-0' style={{ width: '100%', borderCollapse: 'collapse' }}>
                          <thead>
                            <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "12px" }}>
                              <th style={{ width: "10%" }}>आर्थिक वर्ष</th>
                              <th style={{ width: "10%" }}>जिल्हा</th>
                              <th style={{ width: "10%" }}>अर्थसंकल्प शिर्षक क्रमांक</th>
                              <th style={{ width: "10%" }}>अर्थसंकल्प शिर्षकाचे नाव</th>
                              <th style={{ width: "10%" }}>दिनांक</th>
                              <th style={{ width: "15%" }}>या आदेशान्वये वितरीत करावयाची रक्कम</th>
                              <th style={{ width: "12%" }}>आतापर्यंत वितरीत केलेली रक्कम</th>
                            </tr>
                          </thead>
                          <tbody>
                            {
                              tableData.map((val, index) => {
                                return (
                                  <tr key={index} style={{ backgroundColor: index % 2 === 0 ? "#E5F4FB" : "#c6dae7", height: '2rem' }}>
                                    <td className='py-2'>{val.FinancialYear}</td>
                                    <td className='py-2'>{val.District}</td>
                                    <td className='py-2'>{val.HeadID}</td>
                                    <td className='py-2'>{val.HeadName}</td>
                                    <td className='py-2'>{val.ReleaseDate}</td>
                                    <td className='py-2'>
                                      {
                                        val.LimitAllocatedcost || 0
                                      } CR
                                    </td>
                                    <td className='py-2'>{val.ReleaseAmountTillDate} CR</td>
                                  </tr>
                                )
                              })
                            }
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                )
              }
            </>
          )
        }

        {
          ShowMenu == 1 &&
          <div className="col-12" style={{ background: "#EFF3F8", paddingBottom: "6vh", height: "100%" }}>
            <div className="m-auto financeContainer">
              <div className="m-auto budgetElement">
                {loading && (
                  <div
                    style={{
                      position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(255, 255, 255, 0.7)', backdropFilter: 'blur(4px)', zIndex: 9999,
                      display: 'flex', justifyContent: 'center', alignItems: 'center'
                    }}>
                    <div style={{ border: '6px solid #f3f3f3', borderTop: '6px solid #007bff', borderRadius: '50%', width: '60px', height: '60px', animation: 'spin 1s linear infinite' }} />
                    <style>
                      {`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}
                    </style>
                  </div>
                )}

                <div className="excelContainer m-auto">
                  <div className='col-12 m-auto px-3'>
                    <form >
                      <div className='col-12'>
                        <div className='row'>
                          <div className='col-12'>
                            <label className='fw-bold mb-2' style={{ fontSize: "16px" }}>{t("Upload Excel File")}</label>
                          </div>

                          <div className="col-12">
                            <input
                              type="file"
                              className="form-control py-2"
                              style={{ borderRadius: '0' }}
                              accept=".xlsx, .xls"
                              onChange={handleFileUpload}
                            />
                          </div>
                        </div>
                      </div>


                      <p className='my-3 fw-bold' style={{ fontSize: "16px" }}>{t("File Format for Upload")} ::
                        {
                          <a href={`${apiurl}/FinancialReleaseGR/FileFormatForUpload.xlsx`} target='_blank'> {t("File Format for Finance ( Head Wise ) Excel")}
                          </a>}
                      </p>


                      {
                        editIndex &&
                        <div className="col-12">
                          <div className="col-8 m-auto rounded p-4 border border-dark">
                            <form action="">
                              <div className="row">

                                <div className="col-12 my-2">
                                  <div className="row">
                                    <div className="col-6">
                                      <label>अर्थसंकल्प शिर्षकाचे नाव</label>
                                    </div>

                                    <div className="col-6">
                                      <input type="text" value={editIndex.HeadName} disabled />
                                    </div>

                                  </div>
                                </div>

                                <div className="col-12 my-2">
                                  <div className="row">
                                    <div className="col-6">
                                      <label>या आदेशान्वये वितरीत करावयाची रक्कम</label>
                                    </div>

                                    <div className="col-3">
                                      <input type="text" value={editIndex.LimitAllocatedcost} name='LimitAllocatedcost' onChange={(e) => setEditIndex({ ...editIndex, LimitAllocatedcost: e.target.value })} />
                                    </div>

                                    <div className="col-3 my-auto">
                                      <p className='fw-bold my-auto'>कोटी</p>
                                    </div>



                                  </div>
                                </div>

                                <div className="col-12 my-4 text-center">
                                  <button className='btn btn-success px-5 fw-bold' onClick={(e) => handelchangeTablre(e)}>{t("Submit")}</button>
                                </div>

                              </div>
                            </form>
                          </div>
                        </div>
                      }


                      {
                        tableData &&
                        tableData.length > 0 &&
                        (
                          <div className="col-12 my-3">
                            <div className="row">

                              <div className="col-12">


                                <div className="tableContainer m-auto">
                                  <table style={{ border: '1px solid green' }}>
                                    <thead>
                                      <tr style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', height: '2.5rem' }}>
                                        <th style={{ width: "10%", textAlign: "start" }}>आर्थिक वर्ष</th>
                                        {/* <th style={{ width: "10%", textAlign: "start" }}>Head Name</th> */}
                                        <th style={{ width: "10%", textAlign: "start" }}>जिल्हा</th>
                                        <th style={{ width: "10%", textAlign: "start" }}>अर्थसंकल्प शिर्षक क्रमांक</th>
                                        {/* <th style={{ width: "10%", textAlign: "start" }}>Year</th>
                                        <th style={{ width: "20%", textAlign: "start" }}>Budget Head</th>
                                        <th style={{ width: "15%", textAlign: "start" }}>Taluka</th> */}
                                        <th style={{ width: "10%", textAlign: "start" }}>अर्थसंकल्प शिर्षकाचे नाव</th>
                                        {/* <th style={{ width: "10%", textAlign: "start" }}>प्रस्तावाचे नाव</th> */}
                                        <th style={{ width: "10%", textAlign: "start" }}>दिनांक</th>
                                        {/* <th style={{ width: "10%", textAlign: "start" }}>मंजूर रक्कम</th> */}
                                        <th style={{ width: "10%", textAlign: "start" }}>आतापर्यंत वितरीत केलेली रक्कम</th>
                                        <th style={{ width: "10%", textAlign: "start" }}>या आदेशान्वये वितरीत करावयाची रक्कम</th>
                                        {/* <th style={{ width: "10%", textAlign: "start" }}>District-wise Fund Distribution</th> */}
                                        {/* <th style={{ width: "15%", textAlign: "start" }}>Date</th> */}
                                        <th style={{ width: "10%", textAlign: "start" }}></th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {
                                        tableData.map((val, index) => {
                                          return (
                                            <tr key={index} style={{ backgroundColor: index % 2 === 0 ? "#E5F4FB" : "#c6dae7", height: '2rem' }}>
                                              <td style={{ textAlign: "start" }}>{val.FinancialYear}</td>
                                              {/* <td style={{ textAlign: "start" }}>{val.HeadName}</td> */}
                                              <td style={{ textAlign: "start" }}>{val.District}</td>
                                              <td style={{ textAlign: "start" }}>{val.HeadID}</td>
                                              <td style={{ textAlign: "start" }}>{val.HeadName}</td>
                                              {/* <td style={{ textAlign: "start" }}>{val.ProposalID}</td> */}
                                              <td style={{ textAlign: "start" }}>{val.ReleaseDate}</td>
                                              {/* <td style={{ textAlign: "start" }}>{val.ProposalCost} CR</td> */}
                                              <td style={{ textAlign: "start" }}>{val.ReleaseAmountTillDate} CR</td>
                                              {/* <td style={{ textAlign: "start" }}>{val.ReleaseAmount}</td> */}
                                              <td style={{ textAlign: "start" }}>
                                                {
                                                  val.LimitAllocatedcost || 0
                                                } CR
                                              </td>
                                              {/* <td style={{ textAlign: "start" }}>{new Date(val.currentDate).toLocaleString()}</td> */}
                                              <td>
                                                <button className="btn btn-sm btn-primary mx-1" onClick={(e) => handleEdit(e, index)}>{t("Edit")}</button>
                                                {/* <button className="btn btn-sm btn-danger mx-1" onClick={(e) => handleDelete(e, index)}>Delete</button> */}
                                              </td>
                                            </tr>

                                          )
                                        })
                                      }
                                    </tbody>
                                  </table>
                                </div>
                              </div>

                            </div>
                          </div>
                        )
                      }


                      <div className='col-12 text-center mt-4'>
                        <button
                          className='btn'
                          style={{
                            background: "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)", color: "white", borderRadius: "7px"
                          }}
                          onClick={(e) => handleSubmitBulk(e)}
                        > {t("Submit")}</button>
                        <button
                          className='btn btn-danger mx-4'
                          style={{
                            backgroundColor: "#C1272D",
                            color: "white", borderRadius: "7px"
                          }}
                        >
                          <img src={Cancel32} style={{ width: '1.2rem' }} onClick={(e) => { e.preventDefault(); window.location.reload() }} /> {t("Cancel")}</button>
                      </div>
                    </form>
                  </div>
                </div>

              </div>
            </div>
          </div>
        }


      </div>

    </>
  )
};

export default BudgetEstimation;
